module.exports = __webpack_public_path__ + "static/media/cows.b451fb03.png";